import { render, staticRenderFns } from "./BrineIngredientsModal.vue?vue&type=template&id=2378e1b8&scoped=true"
import script from "./BrineIngredientsModal.vue?vue&type=script&lang=js"
export * from "./BrineIngredientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2378e1b8",
  null
  
)

export default component.exports